import { instrumentTypes } from '../../constants';
import { formActionWindowEvent } from '../../form/constants';
import { createEventDescription } from '../../utils/description';
import { triggerHandlers } from '../../utils/handlers';
const createFormActionEvent = createEventDescription(instrumentTypes.FORM);
/**
 * Wraps addEventListener to capture form action breadcrumbs
 * @param handler function that will be triggered
 * @returns wrapped breadcrumb action handler
 * @hidden
 */ const makeReduxEventHandler = (handler)=>(e)=>{
        const event = e;
        if (!event || !event?.detail || event.type !== formActionWindowEvent || !event?.detail?.source) {
            return;
        }
        handler(createFormActionEvent(event.detail));
    };
export const instrumenForm = ()=>{
    if (!window) {
        return;
    }
    const triggerFormHandler = triggerHandlers.bind(null, instrumentTypes.FORM);
    const globalFormEventHandler = makeReduxEventHandler(triggerFormHandler);
    window.addEventListener(formActionWindowEvent, globalFormEventHandler, false);
};
